export const womenLevelThree = [
    {
        "name": "Women Kurtas & Suits",
        "categoryId": "women_kurtas_and_suits",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Kurtis, Tunics & Tops",
        "categoryId": "women_kurtis_tunics_tops",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Sarees",
        "categoryId": "women_sarees",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Ethnic Wear",
        "categoryId": "women_ethnic_wear",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Leggings, Salwars & Churidars",
        "categoryId": "women_leggings_salwars_churidars",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Skirts & Palazzos",
        "categoryId": "women_skirts_palazzos",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Dress Materials",
        "categoryId": "women_dress_materials",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Lehenga Cholis",
        "categoryId": "women_lehenga_cholis",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Dupattas & Shawls",
        "categoryId": "women_dupattas_shawls",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Jackets",
        "categoryId": "women_jackets",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Belts, Scarves & More",
        "categoryId": "women_belts_scarves_more",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Watches & Wearables",
        "categoryId": "women_watches_wearables",
        "parentCategoryName": "Indian & Fusion Wear",
        "parentCategoryId": "women_indian_and_fusion_wear",
        "level":3
    },
    {
        "name": "Women Western Wear",
        "categoryId": "women_western_wear",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Dresses",
        "categoryId": "women_dresses",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Tops",
        "categoryId": "women_tops",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Tshirts",
        "categoryId": "women_tshirts",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Jeans",
        "categoryId": "women_jeans",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Trousers & Capris",
        "categoryId": "women_trousers_capris",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Shorts & Skirts",
        "categoryId": "women_shorts_skirts",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Co-ords",
        "categoryId": "women_coords",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Playsuits",
        "categoryId": "women_playsuits",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Jumpsuits",
        "categoryId": "women_jumpsuits",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Shrugs",
        "categoryId": "women_shrugs",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Sweaters & Sweatshirts",
        "categoryId": "women_sweaters_sweatshirts",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Jackets & Coats",
        "categoryId": "women_jackets_coats",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Blazers & Waistcoats",
        "categoryId": "women_blazers_waistcoats",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Plus Size",
        "categoryId": "women_plus_size",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Maternity",
        "categoryId": "women_maternity",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Sunglasses & Frames",
        "categoryId": "women_sunglasses_frames",
        "parentCategoryName": "Western Wear",
        "parentCategoryId": "women_western_wear",
        "level":3
    },
    {
        "name": "Women Footwear",
        "categoryId": "women_footwear",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Flats",
        "categoryId": "women_flats",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Casual Shoes",
        "categoryId": "women_casual_shoes",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Heels",
        "categoryId": "women_heels",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Boots",
        "categoryId": "women_boots",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Sports Shoes & Floaters",
        "categoryId": "women_sports_shoes_floaters",
        "parentCategoryName": "Footwear",
        "parentCategoryId": "women_footwear",
        "level":3
    },
    {
        "name": "Women Sports & Active Wear",
        "categoryId": "women_sports_active_wear",
        "parentCategoryName": "Sports & Active Wear",
        "parentCategoryId": "women_sports_active_wear",
        "level":3
    },
    {
        "name": "Women Clothing",
        "categoryId": "women_clothing",
        "parentCategoryName": "Sports & Active Wear",
        "parentCategoryId": "women_sports_active_wear",
        "level":3
    },
    {
        "name": "Women Footwear",
        "categoryId": "women_footwear",
        "parentCategoryName": "Sports & Active Wear",
        "parentCategoryId": "women_sports_active_wear",
        "level":3
    },
    {
        "name": "Women Sports Accessories",
        "categoryId": "women_sports_accessories",
        "parentCategoryName": "Sports & Active Wear",
        "parentCategoryId": "women_sports_active_wear",
        "level":3
    },
    {
        "name": "Women Sports Equipment",
        "categoryId": "women_sports_equipment",
        "parentCategoryName": "Sports & Active Wear",
        "parentCategoryId": "women_sports_active_wear",
        "level":3
    },

    {
        "name": "Women Beauty & Personal Care",
        "categoryId": "women_beauty_personal_care",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Makeup",
        "categoryId": "women_makeup",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Skincare",
        "categoryId": "women_skincare",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Premium Beauty",
        "categoryId": "women_premium_beauty",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Lipsticks",
        "categoryId": "women_lipsticks",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Fragrances",
        "categoryId": "women_fragrances",
        "parentCategoryName": "Beauty & Personal Care",
        "parentCategoryId": "women_beauty_personal_care",
        "level":3
    },
    {
        "name": "Women Gadgets",
        "categoryId": "women_gadgets",
        "parentCategoryName": "Gadgets",
        "parentCategoryId": "women_gadgets",
        "level":3
    },
    {
        "name": "Women Smart Wearables",
        "categoryId": "women_smart_wearables",
        "parentCategoryName": "Gadgets",
        "parentCategoryId": "women_gadgets",
        "level":3
    },
    {
        "name": "Women Fitness Gadgets",
        "categoryId": "women_fitness_gadgets",
        "parentCategoryName": "Gadgets",
        "parentCategoryId": "women_gadgets",
        "level":3
    },
    {
        "name": "Women Headphones",
        "categoryId": "women_headphones",
        "parentCategoryName": "Gadgets",
        "parentCategoryId": "women_gadgets",
        "level":3
    },
    {
        "name": "Women Speakers",
        "categoryId": "women_speakers",
        "parentCategoryName": "Gadgets",
        "parentCategoryId": "women_gadgets",
        "level":3
    },
    {
        "name": "Women Jewellery",
        "categoryId": "women_jewellery",
        "parentCategoryName": "Jewellery",
        "parentCategoryId": "women_jewellery",
        "level":3
    },
    {
        "name": "Women Fashion Jewellery",
        "categoryId": "women_fashion_jewellery",
        "parentCategoryName": "Jewellery",
        "parentCategoryId": "women_jewellery",
        "level":3
    },
    {
        "name": "Women Fine Jewellery",
        "categoryId": "women_fine_jewellery",
        "parentCategoryName": "Jewellery",
        "parentCategoryId": "women_jewellery",
        "level":3
    },
    {
        "name": "Women Earrings",
        "categoryId": "women_earrings",
        "parentCategoryName": "Jewellery",
        "parentCategoryId": "women_jewellery",
        "level":3
    },
    {
        "name": "Women Backpacks",
        "categoryId": "women_backpacks",
        "parentCategoryName": "Handbags, Bags & Wallets",
        "parentCategoryId": "women_backpacks_bags_wallets",
        "level":3
    },
    {
        "name": "Women Handbags, Bags & Wallets",
        "categoryId": "women_handbags_bags_wallets",
        "parentCategoryName": "Handbags, Bags & Wallets",
        "parentCategoryId": "women_handbags_bags_wallets",
        "level":3
    },
    {
        "name": "Women Luggages & Trolleys",
        "categoryId": "women_luggages_trolleys",
        "parentCategoryName": "Handbags, Bags & Wallets",
        "parentCategoryId": "women_handbags_bags_wallets",
        "level":3
    }
]